import React from 'react';
import { Select, Form } from 'antd';
import transportFieldsConnect from '../../../common/hoc/transportFieldsConnect';
const Option = Select.Option;
const ModelsTypes = ({ form, modelsTypesByBrands }) => {
  const { getFieldDecorator, getFieldValue } = form;
  const isBrand = getFieldValue('brand_key');
  /*const modelsByBrands =
    brandsActive && brandsActive.length !== 0
      ? modelsTypesByBrands
      : modelsTypes;*/
  const modelsByBrands = modelsTypesByBrands;
  return (
    <Form.Item label="Модель ТС">
      {getFieldDecorator('model_key')(
        <Select
          style={{ width: '100%' }}
          allowClear={true}
          className="ui-select"
          mode="multiple"
          placeholder="Выберите модель ТС"
          dropdownClassName="ui-select__dropdown-multiple"
          showArrow={true}
          maxTagCount={0}
          disabled={!isBrand}
          getPopupContainer={trigger => trigger.parentNode}
        >
          {modelsByBrands &&
            modelsByBrands.map(type => (
              <Option
                key={type.modelKey}
                value={type.modelKey}
                label={type.modelName}
              >
                {type.modelName}
              </Option>
            ))}
        </Select>
      )}
    </Form.Item>
  );
};

export default transportFieldsConnect(ModelsTypes, [
  // 'modelsTypes',
  'modelsTypesByBrands',
]);
